







































































































































import {Vue, Component} from 'vue-property-decorator';
import dataProxy from '@/services/data-proxy.service'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatDate, formatDateTime, formatPrice} from "@/utils/formatters";
import {StetniDogadjaj} from "@/services/BackendProxies";

@Component
export default class PregledSteta extends mixins(ComponentBaseMixin) {
    odDatuma = new Date();
    doDatuma = new Date();
    brojStete = '';
    brojPolise = '';
    brojZapisnika = '';
    vozac = '';
    vozilo = '';
    isBusy = false;
    filterVisible = false;
    stete = [];
    columns = [];
    options = {pagination: true, search: true, showColumns: true};
    dialogVisible = false;
    steta = new StetniDogadjaj();

    created() {
        this.columns = [
            {field: 'broj', title: this.$i18n.t('brojStete'), sortable: true},
            //{field: 'brojZapisnikaOsiguranja', title: this.$i18n.t('brojZapisnikaOsiguranja'), visible: false},
            //{field: 'brojZapisnikaUvidjaja', title: this.$i18n.t('brojZapisnikaUvidjaja'), visible: false},
            {field: 'brojSteteSaZapisnika', title: this.$i18n.t('brojSteteSaZapisnika'), visible: true},
            {field: 'brojPoliseOdOdgovornosti', title: this.$i18n.t('brojPoliseOdOdgovornosti'), visible: false},
            {field: 'datum', title: this.$i18n.t('datum'), formatter: formatDate},
            {field: 'mesto', title: this.$i18n.t('mesto'), visible: false},
            {field: 'vozilo', title: this.$i18n.t('vozilo')},
            {field: 'vozac', title: this.$i18n.t('vozac')},
            {field: 'ukupno', title: this.$i18n.t('ukupno'), formatter: formatPrice, align: 'right'},
            {field: 'datumZakljucenja', title: this.$i18n.t('datumZakljucenja'), formatter: formatDate},
        ];

        this.pretrazi();
    }

    toggleFilter() {
        this.filterVisible = !this.filterVisible;
    }

    get postavljenFilter() {
        return this.odDatuma || this.doDatuma;
    }

    async pretrazi() {
        if (this.isBusy) return ;
        try {
            this.isBusy = true;
            this.stete = await this.loadData(() =>
                dataProxy.vratiStetneDogadjaje(this.odDatuma, this.doDatuma, this.brojStete, this.brojZapisnika, this.brojPolise, +this.vozilo, +this.vozac))();
        } finally {
            this.isBusy = false;
        }
    }

    prikaziStetu(steta: StetniDogadjaj) {
        this.steta = steta;
        this.dialogVisible = true;
    }

    formatDate(date) {
        return formatDate(date);
    }

    async zakljuciStetu() {
        await this.saveData(() => dataProxy.zakljuciStetniDogadjaj(this.steta))();
        await this.pretrazi();
        this.dialogVisible = false;
    }
}
